import { ApiResponse, PaginatedResponse } from 'types/api-response.types';
import { Address } from '../types/address.types';
import { api, unwrapData } from '../../../app/store/api';

export const addressApi = api.injectEndpoints({
    endpoints: (build) => ({
        addresses: build.query<
            PaginatedResponse<Address>,
            void | { per_page?: number; page?: number }
        >({
            transformResponse: unwrapData,
            query: (params) => {
                const { per_page = 15, page = 1 } = params || {};
                return {
                    url: 'user/me/addresses',
                    method: 'GET',
                    params: { per_page, page },
                };
            },
            providesTags: ['Addresses'],
        }),
    }),
});

export const { useAddressesQuery } = addressApi;
